import React from 'react';
import { UX2, components } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const { Link } = components;

// Callers must also pass a `src` prop on this element: react-img-carousel reads
// `child.props.src` on its direct children for prefetch/sizing and equality
// checks (react-img-carousel/utils/areChildImagesEqual).
const CarouselImageLink = ({ externalLink, children, style }) => {
  const tcclString = UX2.utils.TCCLUtils.getTCCLString({
    eid: 'ux2.gallery.external_link.click',
    type: 'click'
  });

  return (
    <Link
      data-tccl={ tcclString }
      linkData={ externalLink }
      style={{ display: 'block', height: '100%', ...style }}
    >
      { children }
    </Link>
  );
};

CarouselImageLink.propTypes = {
  externalLink: PropTypes.object,
  children: PropTypes.node,
  style: PropTypes.object
};

export default CarouselImageLink;
